import { Link } from 'gatsby'
import { buildImageObj } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import { categoryTags } from '../lib/tags'
import { IPostNode } from '../types/postsListing'
import {
  previewItem,
  inSidebar,
  similarColumn,
  leadMediaThumb,
} from './blog-post-preview.module.css'
import { sidebar } from './blog-post-preview-grid.module.css'

function BlogPostPreviewShort({ nodes }: { nodes: IPostNode[] }) {
  return (
    <ul className={sidebar}>
      {nodes &&
        nodes.map(
          ({
            slug: { current },
            mainImage,
            categories,
            title: postTitle,
            id,
          }) => (
            <li key={id} className={`${previewItem} ${inSidebar}`}>
              <div className={similarColumn}>
                <div className={leadMediaThumb}>
                  {mainImage && mainImage.asset && (
                    <Link to={`/blog/${current}`}>
                      <img
                        src={imageUrlFor(buildImageObj(mainImage))
                          .width(600)
                          .height(Math.floor((9 / 16) * 600))
                          .auto('format')
                          .url()}
                        alt={mainImage.alt || 'Blog post image'}
                      />
                    </Link>
                  )}
                </div>
              </div>
              <div className={similarColumn}>
                {categoryTags(categories.slice(0, 2))}
                <Link to={`/blog/${current}`}>
                  <h3 className="mt-4 font-bold">{postTitle}</h3>
                </Link>
              </div>
            </li>
          ),
        )}
    </ul>
  )
}

export default BlogPostPreviewShort
